export enum ChallengeType {
  READING_TIME_CHALLENGE = 'READING_TIME_CHALLENGE',
  TITLES_READ_CHALLENGE = 'TITLES_READ_CHALLENGE',
  CHECKOUT_TITLES_CHALLENGE = 'CHECKOUT_TITLES_CHALLENGE',
}

export enum ChallengeScope {
  ADMIN,
  MONTHLY,
  DAILY,
  NONE,
}

export interface Challenge<T> {
  id?: number;
  name: string;
  type: ChallengeType;
  progress: number;
  target: number;
  isPublic: boolean;
  creationDate: Date;
  expirationDate?: Date;
  contents: T[];
  scope: ChallengeScope;
}

export type AdminChallengeContent = {
  recordId: string;
  title: string;
  coverUrl: string;
  resourceType: string;
}

export type DailyChallengeContent = {
  date: Date;
  totalMinutes: number;
}

export type ChallengeHistory = {
  itemsPerPage: number;
  numPages: number;
  itemsTotal: number;
  page: number;
  items: Challenge<AdminChallengeContent>[];
}

export type MonthlyChallengeContent = AdminChallengeContent;
